/*
 *
 * SignInPage constants
 *
 */

export const SIGN_IN_REQUEST = 'src/SignInPage/SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = 'src/SignInPage/SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = 'src/SignInPage/SIGN_IN_FAILURE';
export const RESEND_VERIFICATION_REQUEST = 'src/SignInPage/RESEND_VERIFICATION_REQUEST';
export const RESEND_VERIFICATION_SUCCESS = 'src/SignInPage/RESEND_VERIFICATION_SUCCESS';
export const RESEND_VERIFICATION_FAILURE = 'src/SignInPage/RESEND_VERIFICATION_FAILURE';
export const RESET_FORM = "RESET_FORM";
